import { createMuiTheme } from 'material-ui/styles';
import red from 'material-ui/colors/red';
import colors from './themeColors';

const appTheme = createMuiTheme({
    palette: {
        primary: {
            main: colors.bloodOrange,
        },
        secondary: {
            main: colors.black,
        },
        error: {
            main: red[500],
        },
    },
});

export default appTheme;



// WEBPACK FOOTER //
// ./src/config/appTheme.js